import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '@/pages/HomePage'
import AboutPage from '@/pages/AboutPage'
import LoginPage from '@/pages/security/LoginPage'
import ChangePasswordPage from '@/pages/security/ChangePasswordPage'
import DashboardPage from '@/pages/dashboard/DashboardPage'
import CustomDashboardPage from '@/pages/dashboard/CustomDashboardPage'
import ClassicDashboardPage from '@/pages/dashboard/ClassicDashboardPage'
import ServerDashboardPage from '@/pages/dashboard/ServerDashboardPage'
import ServersPage from '@/pages/servers/ServersPage'
import AddServerPage from '@/pages/servers/AddServerPage'
import ServerDetailsPage from '@/pages/servers/ServerDetailsPage'

Vue.use(Router)
/**
 * By default the page are public, to secure a page, add the secure property with a value of true as part of the meta property
 *
 * meta: {
 *   secure: false
 * }
 */
export default new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/about',
      name: 'AboutPage',
      component: AboutPage
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage
    },
    {
      path: '/user/password',
      name: 'ChangePasswordPage',
      component: ChangePasswordPage
    },
    {
      path: '/dashboard',
      name: 'DashboardPage',
      component: DashboardPage,
      meta: {
        secure: true
      }
    },
    {
      path: '/dashboard/classic',
      name: 'ClassicDashboardPage',
      component: ClassicDashboardPage,
      meta: {
        secure: true
      }
    },
    {
      path: '/dashboard/custom',
      name: 'CustomDashboardPage',
      component: CustomDashboardPage,
      meta: {
        secure: true
      }
    },
    {
      path: '/dashboard/:serverId',
      name: 'ServerDashboardPage',
      component: ServerDashboardPage,
      meta: {
        secure: true
      }
    },
    {
      path: '/servers',
      name: 'ServersPage',
      component: ServersPage,
      meta: {
        secure: true
      }
    },
    {
      path: '/servers/add',
      name: 'AddServerPage',
      component: AddServerPage,
      meta: {
        secure: true
      }
    },
    {
      path: '/servers/:serverId',
      name: 'ServerDetailsPage',
      component: ServerDetailsPage,
      meta: {
        secure: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js